// extracted by mini-css-extract-plugin
module.exports = {"removeIconFromEntity":"IanosEnergy_removeIconFromEntity__2Aixd"};